/* lv-wishlist (19.08.2026, obsluga bledow 27.08.2026): wlasne bindowanie serduszek Swym/Wishlist Plus.
   Apka przestala bindowac przyciski (flagi add-to-wishlist-*-button = false po jej migracji na embed v2),
   wiec motyw sam obsluguje klik i stan, ale przez API _swat - czyli TA SAMA lista co "Ulubione" w naglowku. */
(function () {
  'use strict';
  /* licznik ulubionych z poprzedniej strony, zanim Swym sie zaladuje */
  try {
    var lvN = parseInt(localStorage.getItem('lvUlubioneLiczba') || '0', 10);
    if (lvN > 0) document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.lv-ulubione-licznik').forEach(function (el) {
        var l = el.querySelector('[data-lv-ulubione-liczba]'); if (l && !l.textContent) { l.textContent = lvN > 99 ? '99+' : String(lvN); el.hidden = false; }
      });
    });
  } catch (e) {}
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    var SEL = '.swym-add-to-wishlist-view-product';
    var inList = {};
    var zajete = {};

    /* 27.08.2026: wczesniej odmowa Swyma konczyla sie cisza - serce nie zmienialo stanu
       i klient nie wiedzial, czy cos sie stalo. Teraz kazda nieudana akcja mowi, co poszlo nie tak. */
    var toast, toastTimer;
    function komunikat(tekst) {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'lv-wl-toast';
        toast.setAttribute('role', 'status');
        document.body.appendChild(toast);
      }
      toast.textContent = tekst;
      toast.classList.add('lv-wl-toast--on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('lv-wl-toast--on'); }, 4000);
    }
    function blad(e, tekst) {
      console.warn('[lv-wishlist]', tekst, e);
      komunikat(tekst);
    }
    /* jedno przejscie przez API Swyma: sukces, blad zwrocony callbackiem i blad rzucony synchronicznie.
       Bez wlasnego poBledzie pokazujemy komunikat; akcja zbiorcza podaje swoj, bo zlicza porazki. */
    function wywolaj(metoda, p, poSukcesie, tekstBledu, poBledzie) {
      var obsluz = poBledzie || function (e) { blad(e, tekstBledu); };
      try {
        swat[metoda](p, poSukcesie, obsluz);
      } catch (e) {
        obsluz(e);
      }
    }

    /* 30.09.2026: licznik pozycji przy ikonie Ulubione w naglowku (jak przy koszyku).
       Ostatnia wartosc trzymamy w localStorage, zeby licznik byl od razu po przejsciu na kolejna strone. */
    function pokazLicznik(n) {
      document.querySelectorAll('.lv-ulubione-licznik').forEach(function (el) {
        var l = el.querySelector('[data-lv-ulubione-liczba]'), o = el.querySelector('[data-lv-ulubione-opis]');
        if (l) l.textContent = n > 99 ? '99+' : String(n);
        if (o) o.textContent = 'Liczba produktów na liście ulubionych: ' + n;
        el.hidden = !(n > 0);
      });
    }
    function licznik() {
      var n = 0;
      Object.keys(inList).forEach(function (k) { if (inList[k]) n++; });
      try { localStorage.setItem('lvUlubioneLiczba', String(n)); } catch (e) {}
      pokazLicznik(n);
    }

    function keyOf(b) { return String(b.getAttribute('data-variant-id') || ''); }
    function paint(b) { b.classList.add('lv-wl-ready'); b.classList.toggle('lv-wl-added', !!inList[keyOf(b)]); }
    function paintAll() { document.querySelectorAll(SEL).forEach(paint); }
    function prodOf(b) {
      return {
        epi: parseInt(b.getAttribute('data-variant-id'), 10),
        empi: parseInt(b.getAttribute('data-product-id'), 10),
        du: b.getAttribute('data-product-url') || (location.origin + location.pathname)
      };
    }
    function refresh() {
      try {
        swat.fetch(function (items) {
          inList = {};
          (items || []).forEach(function (i) { if (i && i.epi != null) inList[String(i.epi)] = true; });
          paintAll();
          licznik();
        });
      } catch (e) { console.warn('[lv-wishlist] nie udalo sie pobrac listy ulubionych', e); paintAll(); }
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest(SEL);
      if (b) {
        e.preventDefault(); e.stopPropagation();
        var p = prodOf(b);
        var k = String(p.epi);
        if (!p.epi) { blad(null, 'Nie udało się rozpoznać produktu. Odśwież stronę i spróbuj ponownie.'); return; }
        if (zajete[k]) return;              // drugi klik w trakcie zapisu robil dwa wpisy
        zajete[k] = true;
        b.classList.add('lv-wl-czeka');
        var koniec = function () { delete zajete[k]; b.classList.remove('lv-wl-czeka'); };
        // po bledzie tez trzeba odblokowac serce, inaczej przycisk jest martwy az do timeoutu
        var poBledzie = function (tekst) {
          return function (e) { koniec(); paintAll(); blad(e, tekst); };
        };
        if (b.classList.contains('lv-wl-added')) {
          wywolaj('removeFromWishList', p,
            function () { inList[k] = false; koniec(); paintAll(); licznik(); },
            null, poBledzie('Nie udało się usunąć produktu z ulubionych. Spróbuj za chwilę.'));
        } else {
          wywolaj('addToWishList', p,
            function () { inList[k] = true; koniec(); paintAll(); licznik(); },
            null, poBledzie('Nie udało się dodać produktu do ulubionych. Spróbuj za chwilę.'));
        }
        setTimeout(function () { if (zajete[k]) { koniec(); paintAll(); } }, 8000);
        return;
      }
      var all = e.target.closest('.lv-wl-all');
      if (all) {
        e.preventDefault();
        var btns = [].slice.call(document.querySelectorAll(SEL));
        var todo = btns.filter(function (x) { return !x.classList.contains('lv-wl-added'); });
        if (!todo.length) { all.classList.add('lv-wl-all--done'); return; }
        all.classList.add('lv-wl-all--busy');
        var done = 0, bledy = 0;
        /* liczymy takze nieudane - inaczej jeden blad zostawial przycisk w stanie "busy" na zawsze */
        function rozlicz() {
          if (done + bledy < todo.length) return;
          paintAll();
          all.classList.remove('lv-wl-all--busy');
          if (bledy) {
            komunikat(done
              ? 'Dodano ' + done + ' z ' + todo.length + ' pozycji. Reszty nie udało się zapisać.'
              : 'Nie udało się dodać pozycji do ulubionych. Spróbuj za chwilę.');
          } else {
            all.classList.add('lv-wl-all--done');
          }
        }
        todo.forEach(function (x) {
          var p = prodOf(x);
          wywolaj('addToWishList', p,
            function () { inList[String(p.epi)] = true; done++; licznik(); rozlicz(); },
            null,
            function (e) { console.warn('[lv-wishlist] pozycja nieudana', e); bledy++; rozlicz(); });
        });
      }
    }, true);

    new MutationObserver(function () {
      var fresh = document.querySelectorAll(SEL + ':not(.lv-wl-ready)');
      for (var i = 0; i < fresh.length; i++) paint(fresh[i]);
      serceObokIlosci();
      serceObokKosza();
    }).observe(document.documentElement, { childList: true, subtree: true });


    /* 20.08.2026: na /cart serduszko ma stac obok kosza (usuwania pozycji), a nie przy zdjeciu.
       Motyw renderuje przycisk w komorce ze zdjeciem, wiec przenosimy go po stronie klienta. */
    function serceObokKosza() {
      if (!document.body.classList.contains('template-cart')) return;
      document.querySelectorAll('.cart-item').forEach(function (row) {
        var serce = row.querySelector(SEL);
        var kosz = row.querySelector('cart-remove-button');
        if (!serce || !kosz || kosz.parentElement.classList.contains('lv-wl-akcje')) return;
        serce.classList.add('lv-wl-kosz');
        // wspolny wiersz na serce i kosz - inaczej komorka "Razem" lamie je w pionie
        var pasek = document.createElement('div');
        pasek.className = 'lv-wl-akcje';
        kosz.parentElement.insertBefore(pasek, kosz);
        pasek.appendChild(serce);
        pasek.appendChild(kosz);
      });
    }
    serceObokKosza();

    /* 20.08.2026: w side carcie serduszko ma stac obok licznika sztuk (ta sama wysokosc),
       a nie w rogu kafelka. Motyw przerysowuje szuflade przy kazdej zmianie, wiec
       przenosimy je ponownie przy kazdym renderze (patrz MutationObserver nizej). */
    function serceObokIlosci() {
      // serce siedzi w .product-content, licznik w .product-quantity - wspolnym
      // rodzicem obu jest .product-description
      document.querySelectorAll('.mini-cart .product-description').forEach(function (poz) {
        var serce = poz.querySelector(SEL);
        var ilosc = poz.querySelector('.product-quantity');
        if (!serce || !ilosc || serce.parentElement === ilosc) return;
        serce.classList.add('lv-wl-mini');
        // tuz za licznikiem, a nie na koncu wiersza - miedzy nimi jest jeszcze cena
        var licznik = ilosc.querySelector('quantity-input');
        var kotwica = licznik ? (licznik.closest('dt') || licznik) : null;
        if (kotwica && kotwica.parentElement === ilosc) {
          ilosc.insertBefore(serce, kotwica.nextSibling);
        } else {
          ilosc.appendChild(serce);
        }
      });
    }
    serceObokIlosci();
    document.addEventListener('cart:updated', serceObokKosza);
    /* zmiany zrobione w panelu Swym (usuniecie pozycji z listy) tez odswiezaja licznik i serca */
    try {
      if (swat.evtLayer && swat.JSEvents) {
        [swat.JSEvents.addedToWishlist, swat.JSEvents.removedFromWishlist].forEach(function (ev) {
          if (ev) swat.evtLayer.addEventListener(ev, function () { setTimeout(refresh, 300); });
        });
      }
    } catch (e) {}
    refresh();
  });
})();
